import React from "react"
import CookieBanner from "react-cookie-banner"
import styled from "styled-components"
import { theme } from "Theme"

const CookieBannerStyled = styled(CookieBanner)`
  min-height: 90px;
  &::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    height: 100%;
    background: rgba(52, 64, 81, 0.996);
    opacity: 0.9;
    backdrop-filter: blur(10px);
  }
  @media (min-width: ${theme.breakpoints.s}) {
  }
  @media (min-width: ${theme.breakpoints.m}) {
  }
  @media (min-width: ${theme.breakpoints.l}) {
  }
`

class CookieBannerComponent extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      accepted: true,
    }
  }

  componentDidMount() {
    this.setState({
      accepted: window ? window.siteUtil.util.getCookie("cxosync-accepted-cookies") : true,
    })
  }

  render() {
    const styles = {
      banner: {
        background: "rgba(0, 0, 0, 0.2)",
        height: "auto",
        position: "fixed",
        bottom: 0,
        fontWeight: "normal",
        zIndex: 9999999999,
        display: "flex",
      },
      button: {
        background: "transparent",
        border: "1px solid white",
        borderRadius: 3,
        color: "white",
        fontSize: "12px",
        fontWeight: "normal",
        height: 30,
        lineHeight: "30px",
        marginTop: -14,
        opacity: 1,
        right: 20,
        width: 66,
      },
      message: {
        position: "relative",
        color: "white",
        display: "flex",
        flexDirection: "column",
        fontSize: "12px",
        fontWeight: "normal",
        marginRight: 110,
        justifyContent: "space-around",
        lineHeight: 1.3,
        padding: "12px 32px",
        textAlign: "left",
      },
      link: {
        fontWeight: "normal",
        margin: 0,
        padding: "12px 0 0",
        textDecoration: "underline",
      },
    }

    return this.state.accepted ? null : (
      <CookieBannerStyled
        className={"cookie-banner"}
        styles={styles}
        message={`By using our site, you acknowledge that you have read and understand our Privacy Policy.`}
        link={
          <a href="/privacy/" target="_blank">
            More information on our use of cookies
          </a>
        }
        buttonMessage=""
        dismissOnScroll={false}
        dismissOnClick={true}
        onAccept={() => this.setState({ accepted: true })}
        cookie="cxosync-accepted-cookies"
      />
    )
  }
}

export default CookieBannerComponent
